import { i18next } from '@frontend/i18n';

export const DASHBOARD_CHART_SIZE = 200;

export const autoRecallFeatureFlags = {
  autoRecallDemoData: 'auto-recall-analytics-demo-data',
  disableAutoRecallInAnalytics: 'disable-auto-recall-in-analytics',
};
export enum VIEW_KEYS {
  CHART = 'CHART',
  TABLE = 'TABLE',
}

export const VIEW_OPTIONS = [
  { value: VIEW_KEYS.CHART, label: i18next.t('Chart'), iconName: 'analytics-small' },
  { value: VIEW_KEYS.TABLE, label: i18next.t('Table'), iconName: 'table-small' },
];

export const DEMO_ACCOUNT_SUFFIXES = ['@demoweave.com', '@weave-users.com'];
